import React from 'react';
import Header from "../components/header";
import ReportPage from '../components/reportPage';

const Report = () => {  
  return (
    <div className="font-Inter flex items-start relative min-h-screen">      
      <div className={`flex flex-col transition-all duration-300 w-full h-screen bg-white-200 "lg:-ml-80"`}>
        <Header />        
        <ReportPage /> 
      </div>
    </div>
  );
};

export default Report;
